import { safeAtomFamily } from 'shared/utils/safe-atom-family';
import { atom } from 'jotai/index';

interface IUserFollowingData {
  cursor: number;
  has_more: boolean;
  data: any[];
}

type TUserFollowingStore = { [key: string]: IUserFollowingData };

export const $UserFollowingStore = atom({} as TUserFollowingStore);

export const $UserFollowing = safeAtomFamily((userLinkName: string) => {
  const a = atom(
    (get) => {
      return get($UserFollowingStore)[userLinkName];
    },
    (get, set, input: IUserFollowingData) => {
      const old = get($UserFollowingStore);

      set($UserFollowingStore, { ...old, [userLinkName]: input });
    },
  );

  a.debugLabel = `$UserFollowing+${encodeURIComponent(userLinkName)}`;

  return a;
});

export const $UserFollowingLoadmore = safeAtomFamily((userLinkName: string) => {
  const a = atom(null, (get, set, input: IUserFollowingData) => {
    const old = get($UserFollowing(userLinkName));
    set($UserFollowing(userLinkName), {
      ...input,
      data: [...old.data, ...input.data],
    });
  });

  a.debugLabel = `$UserFollowingLoadmore+${encodeURIComponent(userLinkName)}`;

  return a;
});
